
import React, { useState } from 'react';
import { Camera, Book, Heart, Play, Pause, Video, Mic, Upload, Users, Home, Settings, Star, Cloud, Moon, Sun, ChevronRight, Plus, Check, X, Mail, Lock, User, ArrowRight } from 'lucide-react';
import { Button } from './Button';
export const BookCard = ({ thumbnail, title, status, duration, onAction }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '1rem', background: '#f9fafb', borderRadius: '0.75rem', cursor: 'pointer' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
        <div style={{ 
          width: '4rem', 
          height: '4rem', 
          background: 'linear-gradient(135deg, #c084fc 0%, #f0abfc 100%)', 
          borderRadius: '0.75rem', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          fontSize: '1.875rem' 
        }}>
          {thumbnail}
        </div>
        <div>
          <h4 style={{ fontWeight: '600', fontSize: '1.125rem', color: '#1f2937', marginBottom: '0.25rem' }}>{title}</h4>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
            {status === 'recorded' && (
              <>
                <span style={{ fontSize: '0.875rem', color: '#059669', display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
                  <Check style={{ width: '1rem', height: '1rem' }} />
                  Recorded
                </span>
                <span style={{ fontSize: '0.875rem', color: '#6b7280' }}>{duration}</span>
              </>
            )}
            {status === 'in-progress' && (
              <span style={{ fontSize: '0.875rem', color: '#ea580c' }}>In Progress - {duration}</span>
            )}
            {status === 'new' && (
              <span style={{ fontSize: '0.875rem', color: '#6b7280' }}>Ready to record</span>
            )}
          </div>
        </div>
      </div>
      <Button variant="primary" onClick={onAction} style={{ padding: '0.5rem 1rem', fontSize: '0.875rem' }}>
        {status === 'new' ? 'Record' : 'View'}
      </Button>
    </div>
  );
};